/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { PatchActivitiesPayload, TransactionPatchResponse } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiActivityV2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-activity-v-2-controller
   * @name PatchActivities
   * @request PATCH:/api/v2/activities
   */
  patchActivities = (data: PatchActivitiesPayload, params: RequestParams = {}) =>
    this.http.request<TransactionPatchResponse, any>({
      path: `/v2/activities`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static patchActivitiesPath = '/v2/activities'
  static patchActivitiesMethod = 'PATCH'
}
